// Commercial — Wrapper widget pour PipelineDistributionFunnel
// (Répartition Pipeline Cible sur les 10 étapes gouvernance, déjà
// componentized dans pages/commercial/PipelineDistributionFunnel.jsx).
import PipelineDistributionFunnel from "../../pages/commercial/PipelineDistributionFunnel";

export default function CommercialDistributionFunnelWidget() {
  // Tenant ACTIF posé par le sélecteur de tenant ; absent => aucun en-tête (tenant de la session).
  const tenantActif = localStorage.getItem("current_tenant_slug") || null;
  return <PipelineDistributionFunnel tenantId={tenantActif} />;
}
